import {
  createFrontendModule,
  createTranslationMessages,
} from '@backstage/frontend-plugin-api';
import { TranslationBlueprint } from '@backstage/plugin-app-react';
import { announcementsTranslationRef } from '@internal/backstage-plugin-announcements';
import { catalogTranslationRef } from '@internal/plugin-catalog';
import { configureDocTranslationRef } from '@internal/backstage-plugin-create-hub';
import { createHubTranslationRef } from '@internal/backstage-plugin-create-hub/alpha';
import { entityRegistrationFlowTranslationRef } from '@internal/backstage-plugin-create-hub';
import { useRoleSetupTranslationRef } from '@internal/backstage-plugin-user-role-setup-react';

const announcementsTranslation = TranslationBlueprint.make({
  name: 'announcements-overrides',
  params: {
    resource: createTranslationMessages({
      ref: announcementsTranslationRef,
      messages: {},
    }),
  },
});

const catalogTranslation = TranslationBlueprint.make({
  name: 'catalog-entity-view-overrides',
  params: {
    resource: createTranslationMessages({
      ref: catalogTranslationRef,
      messages: {},
    }),
  },
});

const configureDocTranslation = TranslationBlueprint.make({
  name: 'configure-doc-overrides',
  params: {
    resource: createTranslationMessages({
      ref: configureDocTranslationRef,
      messages: {},
    }),
  },
});

const createHubTranslation = TranslationBlueprint.make({
  name: 'create-hub-overrides',
  params: {
    resource: createTranslationMessages({
      ref: createHubTranslationRef,
      messages: {},
    }),
  },
});

const entityRegistrationTranslation = TranslationBlueprint.make({
  name: 'entity-registration-overrides',
  params: {
    resource: createTranslationMessages({
      ref: entityRegistrationFlowTranslationRef,
      messages: {},
    }),
  },
});

const userRoleSetupTranslation = TranslationBlueprint.make({
  name: 'user-role-setup-overrides',
  params: {
    resource: createTranslationMessages({
      ref: useRoleSetupTranslationRef,
      messages: {},
    }),
  },
});

export const translationsModule = createFrontendModule({
  pluginId: 'app',
  extensions: [
    announcementsTranslation,
    catalogTranslation,
    configureDocTranslation,
    createHubTranslation,
    entityRegistrationTranslation,
    userRoleSetupTranslation,
  ],
});
